import { createContext, useContext } from 'react';
export const defaultUiConfig = {
  sections: {},
  showPage: {},
  mediaTeaser: {
    displayAgeRating: true,
    displayDate: true,
    displayShowTitle: true
  }
};
export const UiConfigStateContext = /*#__PURE__*/createContext(defaultUiConfig);
const useUiConfigState = () => {
  const context = useContext(UiConfigStateContext);
  if (context === undefined) {
    throw new Error('useUiConfigState must be used within a UiConfigProvider');
  }
  return context;
};
export const useMediaTeaserConfig = () => useUiConfigState().mediaTeaser;
export const useSectionsConfig = () => useUiConfigState().sections;
export const useShowPageConfig = () => useUiConfigState().showPage;